import { AppHTTPService } from '../http-service'

export interface OnboardingProgressUpdateRequest {
  flow?: 'BUILDMODE' | 'WORKFLOW'
  currentStep: number
  completedAt?: string | null
}

export interface Onboarding {
  id: string
  userId: string
  flow: 'BUILDMODE' | 'WORKFLOW'
  currentStep: number
  completedAt?: string | null
  createdAt: string
  updatedAt: string
}

export interface OnboardingResponse {
  data: Onboarding
}

export const updateOnboardingProgress = async (
  onboardingId: string,
  updateData: OnboardingProgressUpdateRequest
): Promise<OnboardingResponse> => {
  const response = await AppHTTPService.axios.put(`/v1/onboardings/${onboardingId}/progress`, updateData)
  return response.data
}

export const getOnboardingStatus = async (onboardingId: string): Promise<OnboardingResponse> => {
  const response = await AppHTTPService.axios.get(`/v1/onboardings/${onboardingId}/status`)
  return response.data
}
